import React from 'react';
import ClassNames from 'classnames';
import ClickAway from '../../mixins/js/ClickAway';
import CssEvent from '../../utils/css-event';
import FlatButton from '../buttons/flat-button/FlatButton';

export default React.createClass({

	mixins: [ ClickAway ],

	manuallyBindClickAway: true,

	propTypes: {
		action: React.PropTypes.string,
		message: React.PropTypes.string.isRequired,
		openOnMount: React.PropTypes.bool,
		onActionTouchTap: React.PropTypes.func,
		status: React.PropTypes.string,
		rounded: React.PropTypes.bool,
		maxWidth: React.PropTypes.string
	},

	getInitialState() {
		return {
			open: this.props.openOnMount || false
		};
	},
	getDefaultProps() {
		return {
			status: "primary",
			rounded: true,
			maxWidth: "568px"
		}
	},
	componentClickAway() {
		this.dismiss();
	},

	componentDidUpdate: function(prevProps, prevState) {
		if (prevState.open != this.state.open) {
			if (this.state.open) {
				//Only Bind clickaway after transition finishes
				CssEvent.onTransitionEnd(this.getDOMNode(), function() {
					this._bindClickAway();
				}.bind(this));
			} else {
				this._unbindClickAway();
			}
		}
	},

	render() {

		let classes = ClassNames('lui-snackbar', `lui-is-${this.props.status}`,{
		  'lui-is-open': this.state.open,
		  'lui-is-rounded': this.props.rounded
		});
		let action;

		if (this.props.action) {
			action = (
				<FlatButton
					className="lui-snackbar-action"
					label={this.props.action}
					onClick={this.props.onActionTouchTap} 
					primary={true}/>
			);
		}

		let styles = {
			maxWidth: this.props.maxWidth
		}

		return (
			<span style={styles} className={classes}>
				<span className ="lui-snackbar-message">
					{this.props.message}
				</span>
				{action}
			</span>
		);
	},

	show() {
		this.setState({
			open: true
		});
	},

	dismiss(){
		this.setState({
			open: false
		});
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/snackbar/Snackbar.js
 **/